module.exports = __webpack_public_path__ + "img/engraving-1.5c37e3e.webp";